import { render, staticRenderFns } from "./LoginReset.vue?vue&type=template&id=52e094a7&"
import script from "./LoginReset.vue?vue&type=script&lang=js&"
export * from "./LoginReset.vue?vue&type=script&lang=js&"
import style0 from "./LoginReset.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports